import React from "react";
                  
export function TermsConditionsPage() {
    return <h1>Terms & Conditions </h1>
}